import React from 'react';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import styles from './index.module.scss';
import { IconSuccess } from '../../../Common/Icon';

export default function CreateSuccess(): React.ReactElement {
  const navigate = useNavigate();

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div>
          <div className={styles.success}>
            <IconSuccess />
          </div>
        </div>
        <h4>Account Created Successfully!</h4>
        <span>
          {'You\'re all set to join the conversation, share your experiences, and explore insights from the community.'}
        </span>
        <Button type="primary" size="large" onClick={() => navigate('/')}>
          Got It
        </Button>
      </div>
    </div>
  );
}
